import styles from './ScenarioCommonButtons.module.css';
import { pencilIcon } from '../../assets/icons';

interface ScenarioButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
  showPill?: boolean;
}

interface IconProps {
  type: 'pencil' | 'delete' | 'add';
}

const ButtonIcon = ({ type }: IconProps): JSX.Element => {
  switch (type) {
    case 'pencil':
      return <img src={pencilIcon} alt="" />;
    case 'delete':
      return <span className={styles.deleteIcon}>×</span>;
    case 'add':
      return <span className={styles.addIcon}>+</span>;
  }
};

const ScenarioButton = ({ 
  onClick, 
  label,
  className = '',
  showPill = true,
  type
}: ScenarioButtonProps & IconProps): JSX.Element => {
  return (
    <button 
      className={`${styles.editFieldButton} ${className}`} 
      onClick={onClick}
      aria-label={label}
    >
      <ButtonIcon type={type} />
      {showPill && (
        <span className={styles.pill}>{label}</span>
      )}
    </button>
  );
};

export const ScenarioEditFieldButton = (props: ScenarioButtonProps): JSX.Element => (
  <ScenarioButton {...props} type="pencil" label={props.label ?? 'Edit'} />
);

export const ScenarioDeleteButton = (props: ScenarioButtonProps): JSX.Element => (
  <ScenarioButton {...props} type="delete" label={props.label ?? 'Delete'} />
);

export const ScenarioAddButton = (props: ScenarioButtonProps): JSX.Element => (
  <ScenarioButton {...props} type="add" label={props.label ?? 'Add'} />
);

export default ScenarioEditFieldButton; 